<template>
    <v-dialog
      v-model="show"
      max-width="400px"
      @click:outside="cancel"
    >
      <v-card>
        <v-card-title>
          <span class="headline">
            Set audio
          </span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              {{ this.name }} ({{ this.audioId }})
            </v-row>
            <v-row>
              to {{ this.playlistType }}:
            </v-row>
            <v-row v-if="toDefault" class="text-h5 pt-2">
              Default
            </v-row>
            <v-row v-else>
              <v-autocomplete
                v-model="toIds"
                :items="listItems"
                :filter="nonDiacriticsSensitiveFilter"
                item-text="name"
                item-value="id"
                hide-selected
                multiple
                chips
                deletable-chips
                :label="playlistType"
                :menu-props="{
                          closeOnContentClick: true,
                        }"
              />
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="cancel"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="setAudio"
          >
            Set
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>

export default {
  name: 'AudioDialogSet',
  props: {
    listItems: {
      type: Array,
      default() {
        return [];
      },
    },
    playlistType: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'default',
    },
    audioId: Number,
    show: {
      type: Boolean,
      default: false,
    },
    toDefault: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      toIds: null,
    };
  },

  mounted() {

  },

  methods: {
    setAudio() {
      this.$requestHelpers
        .post(
          'api/admin/audio/setTo',
          {
            audio_id: this.audioId,
            audiable_id: this.thereToSetId,
            audiable_type: this.playlistType,
          },
        ).then(() => {
          this.$emit('set', true);
        }).catch(() => {
          this.$emit('set', false);
        }).finally(() => {
          this.toIds = null;
        });
    },
    cancel() {
      this.$emit('update:show', false);
    },
  },

  computed: {
    thereToSetId() {
      return this.toDefault ? [-1] : this.toIds;
    },
  },
};
</script>
